import { FormattedMessage } from '@alltrails/shared/react-intl';
import PayWithAppleButton from '../buttons/PayWithAppleButton';
import PayWithPayPalButton from '../buttons/PayWithPayPalButton';
import PayWithAmazonButton from '../buttons/PayWithAmazonButton';
import * as formStyles from '../styles/styles.module.scss';

interface Props {
  submitting: boolean;
  paypalHandler: any;
  applePayHandler: any;
  amazonPayHandler: any;
  showApplePay: boolean;
}

const ExternalPayForm = ({ submitting, paypalHandler, applePayHandler, amazonPayHandler, showApplePay }: Props) => {
  const checkoutWith = <FormattedMessage defaultMessage="Checkout with" />;

  let applePayDiv;
  if (showApplePay) {
    applePayDiv = (
      <div className={formStyles.inputItem}>
        <PayWithAppleButton text={checkoutWith} handler={applePayHandler} />
      </div>
    );
  }

  return (
    <div>
      <div className={formStyles.inputItem}>
        <PayWithPayPalButton text={checkoutWith} handler={paypalHandler} disabled={submitting} />
      </div>
      {applePayDiv}
    </div>
  );
};

export default ExternalPayForm;
